import {HttpResponseCodesEnum} from "@/core/constants/enums/httpResponseCodesEnum";

/**
 * Response key of the 422 returned when disabling users that are assigned to chatters.
 * Backend @see App\Exceptions\Admin\UsersUnderChatterException
 */
export const USERS_UNDER_CHATTER_RESPONSE_KEY = 'usersUnderChatter';

export const BanUnderChatterDecisionEnum = Object.freeze({
    CONFIRM: 'confirm',
    CANCEL: 'cancel',
    SKIP: 'skip',
});

export function getUsersUnderChatterFromError(err) {
    return _.get(err, `response.data.${USERS_UNDER_CHATTER_RESPONSE_KEY}`, []);
}

export function isUsersUnderChatterError(err) {
    return _.get(err, 'response.status') === HttpResponseCodesEnum.UNPROCESSABLE_ENTITY
        && !_.isEmpty(getUsersUnderChatterFromError(err));
}
